import { 
    FETCH_FAQ_REQUEST, 
    FETCH_FAQ_SUCCESS, 
    FETCH_FAQ_FAILURE } from '../../../Constants/actionTypes';

const initialState = {
    loading: false,
    faqList: [],
    error: ''
};

const faqReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_FAQ_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_FAQ_SUCCESS:
            return {
                ...state,
                loading: false,
                faqList: action.payload,
                error: ''
            };
        case FETCH_FAQ_FAILURE:
            return {
                ...state,
                loading: false,
                faqList: [],
                error: action.payload
            };
        default:
            return state;
    }
};

export default faqReducer;